export default __webpack_public_path__ + "static/media/avrata.fb46d5a4.jpg";